import { getAuthTokenClient } from '@/utils/helpers';
import {
  API_URLS,
  getJSONData,
  parseErrorMessage,
  TypeResponseError,
  TypeResponseSuccess,
} from '@/lib/api/config';
import {
  TypeUserPreferenceName,
  TypeUserRecord,
} from '@/lib/api/accountManager/types';

export type EditUserPreference = {
  preference_name: TypeUserPreferenceName;
  preference_value: boolean;
};

export type EditUserData = {
  language?: string;
  phone_number?: string;
  user_preferences?: EditUserPreference[];
};

export type EditUserParams = {
  userUuid: string;
  userData: EditUserData;
  authToken?: string;
};

export async function editUser(params: EditUserParams) {
  const { userUuid, userData, authToken } = params;

  if (!userUuid) {
    console.warn('[editUser]: Missing Required Params');
  }

  const config = {
    method: 'PUT',
    headers: {
      Authorization: authToken ? authToken : await getAuthTokenClient(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ user: userData }),
  };

  const response = await fetch(
    `${API_URLS.ACCOUNT_MANAGER_PROXY}/users/${userUuid}`,
    config,
  );

  const { ok } = response;

  if (!ok) {
    return {
      ok,
      errorMessage: await parseErrorMessage(response),
    } as TypeResponseError;
  }

  return {
    ok,
    data: await getJSONData(response),
  } as TypeResponseSuccess<TypeUserRecord>;
}
